import { element } from 'protractor';
import { FetchCriteriaModel } from './../../../../lib/ng2-sapmp/src/ui-components/custom-grid/shared/model/fetch-criteria.model';
import { Component, OnInit, AfterViewInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SignupService } from './../shared/providers/signup.service';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { StepIndicatorModel, DropdownModel, StepIndicatorService, FormBuilderService } from 'lib/ng2-sapmp/src/ui-components';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { SignUpModel, SignUpInputModel, SignUpOutputModel, ProfileModel, SettingsModel, SessionProfileModel } from './../shared/models/signup.models';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { DROPDOWN, SIGNUPDATA } from 'config';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [FormBuilderService, SignupService],
  encapsulation: ViewEncapsulation.None
})

export class SettingsComponent implements OnInit, AfterViewInit, AfterViewChecked {

  formName: string;
  formConfig: Array<any>;
  formValid = false;
  confirmModalPopup: ConfirmModalPopupModel;
  initModal = false;
  eventEmit: any;
  modalClass: string;
  signupInputData: SignUpInputModel;
  signupOutputData: SignUpOutputModel;
  profile: any;
  selectedProfileName: string;
  gridOptions: Array<GridOptionsModel>;
  initialSignup = false;
  profiles: Array<any>;
  accordionList: boolean;
  settingsData: any;
  authenticatepage: boolean;
  tmpSettings: SettingsModel;
  showError: boolean;
  prodFlag: boolean;
  errorMessage: string;
  pdpIndicator = false;
  emmProductCode: any;
  fanListTitle: any;
  article: any;
  title: any;
  supportArticles: any;
  tmpformConfig: any;
  manageProduct: any;
  test: any;
  counter = 0;
  showOverviewModal: boolean;
  videoId: string;
  supportArticle = false;
  formOutputValue: any;
  getInitialProfileData: any;
  getDefaultProfileData: any;
  profileSize: number;
  pageSize: number;
  sessionProfileModel: SessionProfileModel;
  sizePerPage: number;
  presentDataSet: any;
  nextSetProfiles: any;
  currentSetProfiles: any;

  @ViewChild('accessModal') accessModal: ElementRef;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private pageloaderService: PageLoaderService,
    private stepindicatorService: StepIndicatorService,
    private signupService: SignupService,
    private utilityService: UtilityService,
    private el: ElementRef) {
    this.pageloaderService.setPageLoaderStatus(false);
    const signupData = this.signupService.getSignupModel();
    if (signupData) {
      this.signupInputData = signupData.inputModel;
      this.signupOutputData = signupData.outputModel;
      this.initialSignup = signupData.initialSignup;
      this.authenticatepage = true;
    } else {
      this.authenticatepage = false;
      this.router.navigate(['/signup/accounts']);
    }
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    sessionStorage.setItem('APNRestriction', 'false');
    console.log('Settings page start time => ' + new Date().getTime());
    if (!this.authenticatepage) {
      return;
    }

    this.profiles = [];
    this.gridOptions = [];
    this.settingsData = {};
    this.settingsData.config = SIGNUPDATA.SettingsPage;

    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);

    this.formName = 'SettingsForm';
    this.formConfig = [];
    this.profile = [];

    // this.emmProductCode = sessionStorage.getItem('emmProductCode');
    this.manageProduct = JSON.parse(sessionStorage.getItem('manage-product'));
    this.emmProductCode = this.manageProduct.emmProductCode;
    if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
      this.prodFlag = true;
    } else {
      this.prodFlag = false;
    }

    // this.signupService.fetchJSON(this.utilityService.getEnvConfig().contentUrl.signup.settings).
    //   subscribe(respobj1 => {
        let respobj1 = this.activatedRoute.snapshot.data.pageData.signupsettings;
        this.settingsData.content = respobj1;
        for (const i in this.settingsData.content.descriptionWithModal) {
          if (i) {
            this.settingsData.content.descriptionWithModal[i] = typeof this.settingsData.content.descriptionWithModal[i] === 'string'
             ? this.settingsData.content.descriptionWithModal[i].split(/[[\]]/)
             : this.settingsData.content.descriptionWithModal[i];
          }
        }
        this.signupService.fetchJSON(this.utilityService.getEnvConfig().settingsFormConfig).
          subscribe(respobj2 => {
            respobj1.settingFields.map((item, ind) => {
              return Object.assign(item, respobj2[ind]);
            });
            this.formConfig = respobj1.settingFields;               // Data for form builder
            const pageNumber = 1;
            this.getProfileSettings(pageNumber);
          }, error => this.handleError(error, 'formconfig'));
      // });
      this.supportArticles = [{ id: 1, isActive: true, category: 'Help', description: '', ariaLabel:{
        'expand': 'Show help',
        'collapse': 'Hide help'
        }
        }];
      const pageName = 'signupSettingsPage';
      if (!this.prodFlag) {
        this.signupService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument + pageName).
        subscribe(resp => {
        this.article = resp.supportArticles;
        this.article.category = this.article.availableArticle;
        this.supportArticle = true;
        }, (err) => {
         //   this.handleError(err);
        });
      }
    this.fanListTitle = this.signupService.getSelectedFAN(this.signupOutputData.FANList);

    /* Check Walled garden status from profile data */
      const profileData = JSON.parse(sessionStorage.getItem('user'));
     this.signupOutputData.FANList[this.fanListTitle].forEach(item1 => {
       const selFan = profileData['user'].agreement.
         fans.filter(item2 => item2.fanId === item1.fanId);
       if (selFan.length) {
         item1.pdpindicator = selFan[0].pdpIndicator && selFan[0].pdpIndicator === 'TRUE';
      } else if (item1.pdpindicator === undefined) {
         item1.pdpindicator = false;
       }
     });
     const customAPNFans = this.signupOutputData.FANList[this.fanListTitle].filter(item => item.pdpindicator);
     if (customAPNFans.length) {
       this.pdpIndicator = true;
     }
    if (this.pdpIndicator) {
      sessionStorage.setItem('APNRestriction', 'true');
      this.signupService.createPageLoadProperties('SETTINGS', 'Settings');
    }
  }

  OemForm() {
    this.test = document.getElementsByClassName('settings-form-group')[this.counter];
    if (this.test && this.counter < 3) {
      this.test.style.display = 'none';
      this.counter++;
    }
  }
  ngAfterViewInit() {
    console.log('Settings page end time => ' + new Date().getTime());

  }

  ngAfterViewChecked() {
    if (this.prodFlag) {
      this.OemForm();
    }

  }


  handleError(error, type?) {
    if (error.status === 404) {
      let errorDescription: any;
      errorDescription = error.error;
      if (errorDescription === 'No data found') {
        if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
          this.getInitialProfileData = {
            'profile': [{
              'profileName': 'Profile-somename',
              'profileId': '',
              'settings': {
                'emailEnabled': true,
                'smsEnabled': false
              },
              'defaultProfile': false
            }]
          };
        } else {
          this.getInitialProfileData = {
            'profile': [{
              'profileName': 'Profile-somename',
              'profileId': '',
              'settings': {
                'newDevNwt': true,
                'extDevNwt': false,
                'securityPolicy': '',
                'passCodePolicy': '',
                'emailEnabled': true,
                'smsEnabled': false
              },
              'applications': ['1'],
              'defaultProfile': false
            }]
          };
        }

        errorDescription = this.getInitialProfileData;
        const profileLists = errorDescription.profile;
        const allProfile = profileLists.filter(item => item.defaultProfile === false && item.profileName);
        this.getProfile(allProfile);
      } else {
        this.showError = true;
        this.errorMessage = this.settingsData.content.errorMessages[type];
        this.pageloaderService.setPageLoaderStatus(true);
      }
    } else {
      this.showError = true;
      this.errorMessage = this.settingsData.content.errorMessages[type];
      this.pageloaderService.setPageLoaderStatus(true);
    }
  }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === 'popup') {
      this.initPopupModal(this.article.availableArticle[articleNumber].title, articleNumber);
    }else if (this.article.availableArticle[articleNumber].type === 'url') {
      this.initVideoModal(articleNumber);
    }
  }

  initPopupModal(modalName, articleNumber) {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalSubHeader = '';
    // this.signupService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument+'details/'+modalName).
    this.signupService.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument + 'details/' + modalName).
      subscribe(
        res => {
          this.title = res.articleDetails.name;
          this.confirmModalPopup.modalHeader = this.article.availableArticle[articleNumber].name;
          this.confirmModalPopup.modalMessage = res.articleDetails.content;
        });
    // }
    this.confirmModalPopup.confirmButtonMessage = 'OK';
    this.confirmModalPopup.showCancelButton = false;

    this.initModal = true;
    this.eventEmit = document.activeElement;
  }

  initVideoModal(articleNumber) {
    this.videoId = this.article.availableArticle[articleNumber].url;
    this.showOverviewModal = true;
  }
  closeOverviewModal() {
    this.showOverviewModal = false;
  }

  getProfileSettings(pageNumber) {
    if (this.signupInputData.profileList.length) {
      if (this.pdpIndicator) {
        this.signupOutputData.profile.settings.extDevNwt = false;
        this.signupOutputData.profile.settings.newDevNwt = false;
      }
      let totalRecords = JSON.parse(sessionStorage.getItem('ProfileSize'));
      this.profileSize = totalRecords;
      this.setFormSettings(this.signupOutputData.profile.settings);
      this.checkDropDownOrAccordion();
    } else {
      console.log('Settings API request time => ' + new Date().getTime());
      this.pageSize = this.utilityService.getEnvConfig().profilesPageSize;
       this.signupService.getProfileSettings(this.signupInputData.companyId, this.pageSize, pageNumber, this.emmProductCode).
        subscribe(respobj => {
          const profileLists = respobj.profile;
          this.profileSize = respobj.totalNumberProfiles;
          sessionStorage.setItem('ProfileSize', JSON.stringify(this.profileSize));
          const defaultProfile = profileLists.filter(item => item.defaultProfile === true && item.profileName)[0];
          const allProfile = profileLists.filter(item => item.defaultProfile === false && item.profileName);
          /* Add defaultProfile as Recommend and create new in that list */
          if (defaultProfile === undefined) {
            if (this.emmProductCode === 'DMPSKME' || this.emmProductCode === 'DMPGZTP') {
            this.profileSize = this.profileSize + 2;
            this.getDefaultProfileData = {
                  'profileName': 'Standard profile',
                  'profileId': '',
                  'settings': {
                    'emailEnabled': true,
                    'smsEnabled': false
                  },
                  'defaultProfile': false
                };
            } else {
              this.getDefaultProfileData = {
                    'profileName': 'Standard profile',
                    'profileId': '',
                    'settings': {
                      'newDevNwt': true,
                      'extDevNwt': false,
                      'securityPolicy': '',
                      'passCodePolicy': '',
                      'emailEnabled': true,
                      'smsEnabled': false
                    },
                    'applications': ['com.att.tv'],
                    'defaultProfile': false
                  };
              }
            const recommendedProfile = Object.assign({}, this.getDefaultProfileData);
            recommendedProfile.profileName = 'Standard profile';
            recommendedProfile.disableSort = true;
            const createNewProfile = Object.assign({}, this.getDefaultProfileData);
            createNewProfile.profileName = 'Create new';
            createNewProfile.disableSort = true;
            allProfile.unshift(recommendedProfile, createNewProfile);
            this.getProfile(allProfile);
          } else {
            this.profileSize = this.profileSize + 2;
            const recommendedProfile = Object.assign({}, defaultProfile);
            recommendedProfile.profileName = 'Standard profile';
            recommendedProfile.disableSort = true;
            const createNewProfile = Object.assign({}, defaultProfile);
            createNewProfile.profileName = 'Create new';
            createNewProfile.disableSort = true;
            allProfile.unshift(recommendedProfile, createNewProfile);
            this.getProfile(allProfile);
            console.log('Settings API response time => ' + new Date().getTime());
          }
        },
            error => this.handleError(error, 'profile'));
    }
  }

  getProfile(respobj: Array<ProfileModel>) {                // triggered on Page load
    this.signupInputData.profileList = respobj;             // Profile data

    const selectedProfile = this.signupOutputData.FANList.revisedFanList.map(item => item.profileName)
      .filter((value, index, self) => self.indexOf(value) === index);

    if (this.fanListTitle === 'revisedFanList' && selectedProfile.length === 1) {
      this.signupInputData.profileList.forEach(item => {
        if (item.profileName === selectedProfile[0]) {
          this.signupOutputData.profile = Object.assign({}, item);
          item.selected = true;
        }
      });

    } else {
      this.signupOutputData.profile = JSON.parse(JSON.stringify(respobj.slice()[0]));
      if (this.signupOutputData && this.signupOutputData.profile && this.signupOutputData.profile.settings && this.pdpIndicator) {
        this.signupOutputData.profile.settings.extDevNwt = false;
        this.signupOutputData.profile.settings.newDevNwt = false;
      }
      this.signupInputData.profileList[0].selected = true; 
    }
    this.setFormSettings(Object.assign({}, this.signupOutputData.profile.settings));
    this.checkDropDownOrAccordion();
  }

  checkDropDownOrAccordion() {
    if (this.profileSize > 20) {
      this.initProfileAccordion();
    } else {
      this.initProfileDropDown();
    }
    this.selectedProfileName = this.signupOutputData.profile.profileName;
    this.pageloaderService.setPageLoaderStatus(true);
  }

  initProfileDropDown() {
    this.signupInputData.profileList.forEach(profile => {
      const dropDownList = new DropdownModel();
      dropDownList.name = profile.profileName;
      this.profile.push(dropDownList);
    });
  }

  initProfileAccordion() {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = false;

    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: true,
      totalRecords: this.profileSize
    };

    options.Paginations = pagination;
    //options.gridData = this.signupInputData.profileList;
    // Pushing extra data to next page START
    let backupData: Array<SessionProfileModel> = [];
    if (this.signupInputData.profileList.length > this.pageSize) {
      this.nextSetProfiles = this.signupInputData.profileList.slice(this.pageSize, this.signupInputData.profileList.length);
      this.currentSetProfiles = this.signupInputData.profileList.slice(0, this.pageSize);
      this.sessionProfileModel = new SessionProfileModel(1, this.currentSetProfiles);
    } else {
      //this.nextSetProfiles = [];
      //this.currentSetProfiles = [];
      this.sessionProfileModel = new SessionProfileModel(1, this.signupInputData.profileList);
    }
    backupData.push(this.sessionProfileModel);
    this.setToSessionProfiles(backupData);
    // Pushing extra data to next page END
    options.gridData = this.sessionProfileModel.sessionProfiles.slice(0, pagination.recordsPerPage);
    options.columnDefinitions = this.settingsData.config.columnDefinitions;
    this.gridOptions.push(options);
    this.profiles.push({ id: 1, isActive: false, category: 'Deployment profiles', content: '' });
  }

  gridEventChanges(fetchCriteria: FetchCriteriaModel) {
    let startRange: number;
    let flag = false;
    let backupData: Array<SessionProfileModel> = [];
    this.sizePerPage = this.gridOptions[0].Paginations.recordsPerPage;
    let pageNumber = (fetchCriteria.offset / this.sizePerPage) + 1;
    const dataPerSet = Math.ceil(this.pageSize / fetchCriteria.limit);
    let requiredSet = Math.ceil((fetchCriteria.offset + fetchCriteria.limit) / this.pageSize);
    // If offset reaches beyond the pageSize
    if (fetchCriteria.offset >= this.pageSize) {
      startRange = fetchCriteria.offset % this.pageSize;
    } else {
      startRange = fetchCriteria.offset;
    }
    // If required data is available in the sessionProfileModel only
    if (requiredSet === this.sessionProfileModel.setNo) {
      this.presentDataSet = this.sessionProfileModel.sessionProfiles.slice(startRange, (startRange + this.sizePerPage));
      this.computeGrid(pageNumber);
    } 
    // If required data is not available in sessionProfileModel but available in sessionStorage or Backend
    else {
      // If required data is available in sessionStorage
      backupData = JSON.parse(sessionStorage.getItem('backupProfiles'));
      backupData.forEach(element => {
        if (element.setNo === requiredSet) {
          this.sessionProfileModel = new SessionProfileModel(requiredSet, element.sessionProfiles);
          this.presentDataSet = this.sessionProfileModel.sessionProfiles.slice(startRange, (startRange + this.sizePerPage));
          flag = true;
          this.computeGrid(pageNumber);
        }
      });
      // If required data is  not available in model and session then Backend Hit
      if (!flag) {
        this.pageloaderService.setPageLoaderStatus(false);
        this.signupService.getProfileSettings(this.signupInputData.companyId, this.pageSize, requiredSet, this.emmProductCode)
        .toPromise()
        .then(respObj => {
          this.pageloaderService.setPageLoaderStatus(true);
          respObj.profile = respObj.profile.filter(item => item.defaultProfile === false);
          if(this.nextSetProfiles !== null && this.nextSetProfiles !== undefined){
            this.nextSetProfiles.forEach(element => respObj.profile.unshift(element));
          }    
          if (respObj.profile.length > this.pageSize) {     
            this.nextSetProfiles = respObj.profile.slice(this.pageSize, respObj.profile.length);
            this.currentSetProfiles = respObj.profile.slice(0, this.pageSize);
            this.sessionProfileModel = new SessionProfileModel(requiredSet, this.currentSetProfiles);
          } else {   
            this.nextSetProfiles = [];
            this.currentSetProfiles = [];
            this.sessionProfileModel = new SessionProfileModel(requiredSet, respObj.profile);
          } 
          backupData = JSON.parse(sessionStorage.getItem('backupProfiles'));
          backupData.push(this.sessionProfileModel);
          this.setToSessionProfiles(backupData);
          this.presentDataSet = this.sessionProfileModel.sessionProfiles.slice(startRange, (startRange + this.sizePerPage));
          this.computeGrid(pageNumber);
        })
        .catch(error => this.handleError(error, 'profile'));
      }
    }
  }

  setToSessionProfiles(sessionProfileModel: Array<SessionProfileModel>){
    sessionStorage.setItem('backupProfiles', JSON.stringify(sessionProfileModel));
  };

  computeGrid(pageNumber){
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = false;

    const pagination = {
      recordsPerPage: 20,
      currentPage: pageNumber,
      isServerSide: true,
      totalRecords: this.profileSize
    };
    options.Paginations = pagination;
    options.gridData = this.presentDataSet;
    options.columnDefinitions = this.settingsData.config.columnDefinitions;
    this.gridOptions = [];
    this.gridOptions.push(options);
  }

  setFormSettings(settings) {
    this.tmpformConfig = this.formConfig.slice();
    // set the settings as per each profile
    this.formConfig = [];
    for (const obj of this.tmpformConfig) {
      if (this.pdpIndicator && obj.title === 'Network restriction') {
        obj.description = this.settingsData.content.descriptionWithModal.walledGarden[0];
        obj.link = this.settingsData.content.descriptionWithModal.walledGarden[1];
      } else if (!this.pdpIndicator && obj.title === 'Network restriction') {
         obj.description = this.settingsData.content.descriptionWithModal.networkDescription[0];
         obj.description2 = this.settingsData.content.descriptionWithModal.networkDescription[1];
        obj.link = this.settingsData.content.descriptionWithModal.networkDescriptionLink;
       // obj.description = this.settingsData.content.descriptionWithModal.walledGarden[0];
      }
      obj.fields.forEach(field => {
        if (this.pdpIndicator && field.formControlName.indexOf('DevNwt') > -1) {
          field.initialValue = false;
        } else {
          field.initialValue = settings[field.formControlName];
        }
        field.disabled = this.pdpIndicator;
      });
    }
    this.formConfig = this.tmpformConfig;
  }

  onProfileSelect(selectedProfile) {
    this.selectedProfileName = selectedProfile.name === undefined ? selectedProfile.profileName : selectedProfile.name;
    for (const i in this.signupInputData.profileList) {
      if (this.selectedProfileName === this.signupInputData.profileList[i].profileName) {
        this.signupInputData.profileList[i].selected = true;
        this.signupOutputData.profile = Object.assign({}, this.signupInputData.profileList[i]);
        if (this.pdpIndicator) {
          this.signupOutputData.profile.settings.extDevNwt = false;
          this.signupOutputData.profile.settings.newDevNwt = false;
        }
        this.setFormSettings(this.signupInputData.profileList[i].settings);
      } else {
        this.signupInputData.profileList[i].selected = false;
      }
    }
  }

  getFormConfigDetails(formOutputValue) {
    this.formValid = formOutputValue.valid;
    if (this.formValid) {
      if (formOutputValue.value.extDevNwt !== this.signupOutputData.profile.settings.extDevNwt
        || formOutputValue.value.newDevNwt !== this.signupOutputData.profile.settings.newDevNwt) {
        if (!this.prodFlag) {
          this.confirmRequest(formOutputValue.value);
        }
        this.tmpSettings = formOutputValue.value;

      } else {
        this.signupOutputData.profile.settings = formOutputValue.value;
      }
    }
  }

  confirmRequest(settings) {
    if (this.formValid) {
      this.confirmModalPopup = new ConfirmModalPopupModel();
      const onText = `
      ON</h4><p>If ON, users will only be able to use the AT&T cellular data network to download the IBM MaaS360<sup>®</sup> MDM app,
      required for managing devices. They will still be able to make voice calls, send/receive texts and multimedia messages,
      and to access the Internet via Wi-Fi.</p>
      `;
      const offTextNew = `
      OFF</h4><p>${this.pdpIndicator ? "New devices will be able to access the Internet via the AT&T cellular data network." : "If OFF, the network restrictions will not apply. <a href = 'faq' target='_blank'>Learn more</a>"}</p>
      `;
      const offTextExisting = `
      OFF</h4><p>${this.pdpIndicator ? "Existing devices will be able to access the Internet via the AT&T cellular data network." :
          "If OFF, the network restrictions will not apply. <a href = 'faq' target='_blank'>Learn more</a>"}</p>
      `;
      this.confirmModalPopup.modalMessage = `
      <p>${this.pdpIndicator ? "The settings you've chosen will determine whether or not enrolled devices can access the internet via the" +
          " AT&T cellular data network. To verify your choices, click <strong>Confirm</strong>." : "The settings you've selected will affect" +
          " all devices on your network. Review your selections and confirm they are correct."}</p>
      <h3>Selected settings</h3>
      <h4>Network restriction for new devices: ${settings.newDevNwt ? onText : offTextNew}
      <h4>Network restriction for existing devices: ${settings.extDevNwt ? onText : offTextExisting}
      ` ;
      this.confirmModalPopup.modalSubHeader = '';
      this.confirmModalPopup.modalHeader = 'Confirm your settings';
      this.confirmModalPopup.confirmButtonMessage = 'Confirm';
      this.confirmModalPopup.confirmButtonAccessibilityText = 'Confirm.';
      this.confirmModalPopup.showCancelButton = true;
      this.modalClass = 'modal-lg';
      this.initModal = true;
	  this.eventEmit = document.activeElement;
      this.signupService.createPageLoadProperties('COFIRMREQUESTMODAL', 'Settings');
    }
  }

  launchSupportModal() {                                      // modal popover if setup support link is clicked
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalMessage = '<p>You can customize the following settings:</p><ul> <li>&ensp; &ensp; •	 &ensp;	Network restriction </li> <li>&ensp; &ensp; •	 &ensp;	Security policy</li><li>&ensp; &ensp; •	 &ensp;	Passcode policy</li><li>&ensp; &ensp; •	 &ensp;	Notifications</li></ul>';
    this.confirmModalPopup.modalSubHeader = '';
    this.confirmModalPopup.modalHeader = '';
    this.confirmModalPopup.confirmButtonMessage = 'OK';
    this.confirmModalPopup.confirmButtonAccessibilityText = 'OK.';
    this.confirmModalPopup.showCancelButton = false;
    this.eventEmit = document.activeElement;
    this.initModal = true;
    this.signupService.createPageLoadProperties('SETTINGSMODAL', 'Settings');

  }

  closeModal(confirm, buttonMsg) {
    this.initModal = false;
    this.signupService.createPageLoadProperties('SETTINGS', 'Settings');
    if (buttonMsg === 'Confirm') {
      if (confirm && this.pdpIndicator) {
        this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
        this.router.navigate(['/signup/applications']);
      } else if (confirm) {
        this.signupOutputData.profile.settings = this.tmpSettings;
        this.signupService.createPageLoadProperties('SETTINGS', 'Settings');
      } else if (!this.pdpIndicator) {
        this.setFormSettings(this.signupOutputData.profile.settings);
        this.signupService.createPageLoadProperties('SETTINGS', 'Settings');
      }
    }
  }

  continueToNext() {
    if (!this.prodFlag) {
      /*if (this.pdpIndicator) {
         this.formValid = true;
         this.confirmRequest(this.signupOutputData.profile.settings);
       } else {*/
        this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
        this.router.navigate(['/signup/applications']);
     // }
    } else {
      this.signupService.saveSignupModel(this.signupInputData, this.signupOutputData, this.initialSignup);
      this.router.navigate(['/signup/startdate']);
    }
  }

  backToPrevious(event) {
    event.preventDefault();
    this.router.navigate(['/signup/accounts']);
  }
}
